import React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { AttachFile } from '@mui/icons-material';

type FileUploadButtonProps = {
  title?: string;
  labels?: {
    default: string;
    change: string;
  };
  imgUrl?: string;
  onSelectFile?: (file: File) => void;
  error?: string;
};

export const FileUploadButton = ({
  title,
  labels = {
    default: 'Attach a file',
    change: 'Change file',
  },
  imgUrl,
  onSelectFile = () => {},
  error,
}: FileUploadButtonProps) => {
  const theme = useTheme();

  const isError = !!error;
  const errorBasedColor = isError ? theme.palette.error.main : theme.palette.text.secondary;

  return (
    <>
      {!!title && (
        <Box marginBottom={1} display="flex" alignItems="center">
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: 12,
              color: errorBasedColor,
            }}
          >
            {title}
          </Typography>
        </Box>
      )}

      <Button
        variant="outlined"
        component="label"
        fullWidth
        sx={{
          borderRadius: 1,
          height: 56,
          color: errorBasedColor,
          borderColor: errorBasedColor,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
          }}
        >
          <Box paddingTop={1} marginRight={2}>
            <AttachFile
              sx={{
                transform: 'rotate(45deg)',
              }}
            />
          </Box>

          <Typography>{imgUrl ? labels.change : labels.default}</Typography>
          <input
            type="file"
            hidden
            onChange={(event: any) => {
              const [file] = event.target.files || [null];

              if (file) {
                onSelectFile(file);
              }
            }}
          />

          {!!imgUrl && (
            <Box
              sx={{
                position: 'absolute',
                right: 0,
                top: 0,
                width: 80,
                height: '100%',
              }}
            >
              <img
                src={imgUrl}
                alt="Attatched file"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          )}
        </Box>
      </Button>

      {isError && (
        <Typography variant="caption" color={theme.palette.error.main} sx={{ marginLeft: '14px' }}>
          {error}
        </Typography>
      )}
    </>
  );
};
